module.exports = __webpack_public_path__ + "img/green-hairy-grass-01.7c1ca962.png";